import Vue from "vue";
import SingleChatController from "@/components/Chat/SingleChatController";

const eventBus = new Vue();

export default eventBus;

export interface SnackBarEvent {
    message: string;
    timeout?: number;
    priority: SnackPriorityToColor;
    actionButtonText?: string;
    actionButtonRoute?: string;
}

export const enum SnackPriorityToColor {
    success = "primary",
    warning = "warning",
    error = "error",
}

export interface RequestSingleChatControllerEvent {
    id: string;
    callBack: (chatController: SingleChatController) => void;
}
export const enum DeclaredEvents {
    snackBarMessage = "snackBarMessage",
    singleChatControllerDisponivel = "singleChatControllerDisponivel",
    requestSingleChatController = "requestSingleChatController",
    chatEncerrado = "chatEncerrado",
    logout = "logout",
    login = "login",
}
